export enum ColorTheme {
  LIGHT = "LIGHT",
  DARK = "DARK",
}
